import s from "crypto-js";
const S = Object.prototype.toString;
function i(t, e) {
  return S.call(t) === `[object ${e}]`;
}
function O(t) {
  return typeof t != "undefined";
}
function y(t) {
  return typeof t == "undefined";
}
function m(t) {
  return t === null;
}
function h(t) {
  return t === "";
}
function u(t) {
  return !m(t) && i(t, "Object");
}
function x(t) {
  return t && Array.isArray(t);
}
function T(t) {
  return i(t, "String");
}
function I(t) {
  return i(t, "Number");
}
function _(t) {
  return i(t, "Boolean");
}
function L(t) {
  return i(t, "Date");
}
function R(t) {
  return i(t, "RegExp");
}
function a(t) {
  return typeof t == "function";
}
function z(t) {
  return i(t, "Promise") && u(t) && a(t.then) && a(t.catch);
}
function C(t) {
  return u(t) && !!t.tagName;
}
function j(t) {
  return m(t) || y(t);
}
function D(t) {
  return j(t) || h(t);
}
function U(t) {
  return x(t) || T(t) ? t.length === 0 : t instanceof Map || t instanceof Set ? t.size === 0 : u(t) ? Object.keys(t).length === 0 : !1;
}
function M(t, e = "") {
  return D(t) ? e : t;
}
function $(t) {
  return /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/.test(t);
}
const d = "__SecretKey__";
function p(t) {
  const e = JSON.stringify(t);
  return s.AES.encrypt(e, d).toString();
}
function l(t) {
  const n = s.AES.decrypt(t, d).toString(s.enc.Utf8);
  return n ? JSON.parse(n) : null;
}
const E = 60 * 60 * 24 * 7;
function B(t, e, n = E) {
  const o = { value: e, expire: n !== null ? new Date().getTime() + n * 1e3 : null }, r = p(o);
  window.localStorage.setItem(t, r);
}
function J(t) {
  const e = window.localStorage.getItem(t);
  if (e) {
    let n = null;
    try {
      n = l(e);
    } catch (o) {
    }
    if (n) {
      const { value: o, expire: r } = n;
      if (r === null || r >= Date.now())
        return o;
    }
    return b(t), null;
  }
  return null;
}
function W(t) {
  const e = window.localStorage.getItem(t);
  if (e) {
    let n = null;
    try {
      n = l(e);
    } catch (o) {
    }
    if (n) {
      const { expire: o } = n;
      return o;
    }
    return null;
  }
  return null;
}
function b(t) {
  window.localStorage.removeItem(t);
}
function F() {
  window.localStorage.clear();
}
function H(t, e) {
  const n = p(e);
  sessionStorage.setItem(t, n);
}
function P(t) {
  const e = sessionStorage.getItem(t);
  let n = null;
  if (e)
    try {
      n = l(e);
    } catch (o) {
    }
  return n;
}
function Z(t) {
  window.sessionStorage.removeItem(t);
}
function k() {
  window.sessionStorage.clear();
}
function w(t, e) {
  const n = new ResizeObserver((o) => {
    e(o[0].contentRect);
  });
  return n.observe(t), n;
}
const A = (t) => {
  let e;
  t.directive("resize", {
    mounted(n, o) {
      e = w(n, o.value);
    },
    beforeUnmount() {
      e == null || e.disconnect();
    }
  });
};
w.install = A;
const c = /* @__PURE__ */ new WeakMap();
function f(t, e, n = "") {
  let o;
  if (c.get(t) ? o = c.get(t) : (o = t.attachShadow({ mode: "closed" }), c.set(t, o)), o.innerHTML = e, n) {
    const r = document.createElement("style");
    r.textContent = n, o.appendChild(r);
  }
}
function g(t) {
  let e, n;
  return typeof t.value == "object" ? (e = t.value.htmlText, n = t.value.styleText) : e = t.value, { htmlText: e, styleText: n };
}
const K = {
  install: (t) => {
    t.directive("richText", {
      mounted(e, n) {
        const { htmlText: o, styleText: r } = g(n);
        f(e, o, r);
      },
      updated(e, n) {
        const { htmlText: o, styleText: r } = g(n);
        f(e, o, r);
      }
    });
  }
};
export {
  F as clearLocal,
  k as clearSession,
  l as decrypto,
  p as encrypto,
  J as getLocal,
  W as getLocalExpire,
  P as getSession,
  M as ifNull,
  i as is,
  x as isArray,
  _ as isBoolean,
  L as isDate,
  O as isDef,
  C as isElement,
  U as isEmpty,
  a as isFunction,
  m as isNull,
  j as isNullOrUndef,
  D as isNullOrWhitespace,
  I as isNumber,
  u as isObject,
  z as isPromise,
  R as isRegExp,
  T as isString,
  y as isUndef,
  $ as isUrl,
  h as isWhitespace,
  b as removeLocal,
  Z as removeSession,
  B as setLocal,
  H as setSession,
  w as useResize,
  K as useRichText
};
